import { ChangeEvent } from "react";
import SSelect from "../../../shared/s_select/s_select";
import { Content, Label } from "../styles";

interface Option {
  value: number;
  name: string | null | undefined;
}

interface WorkingTemplateSelectProps {
  isActiveWorkType: boolean;
  workingTemplateOptions: Option[];
  selectedWorkingTemplateIndex: number;
  setWorkingTemplateIndex: (index: number) => void;
}

const WorkingTemplateSelect = ({
  isActiveWorkType,
  workingTemplateOptions,
  selectedWorkingTemplateIndex,
  setWorkingTemplateIndex
}: WorkingTemplateSelectProps) => {
  if (!isActiveWorkType) return null;

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setWorkingTemplateIndex(Number(event.target.value));
  };

  return (
    <Content style={{ gridColumn: "span 3", gridRow: "" }}>
      <Label>{`근무제`}</Label>
      <SSelect
        id="underAgeWorkScheduleForApproval"
        value={selectedWorkingTemplateIndex}
        onChange={handleChange}
      >
        {workingTemplateOptions.map(item => {
          const option = item as Option;
          const optionValue = option.value === undefined ? item : option.value;
          const optionName = option.name === undefined ? item : option.name;
          return (
            <option
              value={optionValue as string | number}
              key={optionValue as string | number}
            >
              {optionName}
            </option>
          );
        })}
      </SSelect>
    </Content>
  );
};

export default WorkingTemplateSelect;
